module.exports = __webpack_public_path__ + "static/create-sharelinks-tablet-33356a9b1dc182bf533c4b35c0cf21ef.png";